/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ZoomInIcon = ({ width = 24, height = 24, hidden = false, title = 'Zoom In' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M21.5 14H18v-3.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V14h-3.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H14v3.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V18h3.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5Z"
    />
    <path
      d="M35.173 32.215 27.256 24.3a14.031 14.031 0 1 0-2.956 2.957l7.916 7.916a2.1 2.1 0 0 0 2.958-2.958ZM6 16a10 10 0 1 1 10 10A10 10 0 0 1 6 16Z"
    />
  </svg>`;
};
